import { render, staticRenderFns } from "./StockDebt.vue?vue&type=template&id=676f909a&scoped=true&"
import script from "./StockDebt.vue?vue&type=script&lang=js&"
export * from "./StockDebt.vue?vue&type=script&lang=js&"
import style0 from "./StockDebt.vue?vue&type=style&index=0&id=676f909a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f909a",
  null
  
)

export default component.exports